import { Component } from 'solid-js'

interface Props {
  title: string
  value: string
  onClick: (value: string, replacePrompt: boolean) => void
  replacePrompt?: boolean
}

const GenerateImageOptionButton: Component<Props> = (props) => {
  return (
    <button
      onClick={() => props.onClick(props.value, props.replacePrompt || false)}
      class="flex flex-row rounded-md border border-cosplay-gray-100/50 bg-[#171717] px-[10px] py-[6px]"
    >
      <img src="/images/generate-image-plus-btn.png" class="h-[17px] w-[17px]" />
      <p class="m-0 ml-2 p-0 text-xs">{props.title}</p>
    </button>
  )
}

export default GenerateImageOptionButton
